import * as React from "react";
import { createContext, useContext } from "react";
const EscapeHandlerStackContext = createContext(null);
EscapeHandlerStackContext.displayName = "EscapeHandlerStackContext";
const useEscapeHandlerStack = () => {
  return useContext(EscapeHandlerStackContext);
};
const EscapeHandlerStackProvider = ({ children }) => {
  const [handlers, setHandlers] = React.useState([]);
  const registerHandler = (handler) => {
    setHandlers((prevHandlers) => [...prevHandlers, handler]);
  };
  const unregisterHandler = (id) => {
    setHandlers((prevHandlers) => prevHandlers.filter((handler) => handler.id !== id));
  };
  const handleOnEscape = React.useCallback(
    (event) => {
      if (event.key === "Escape" || event.key === "Esc") {
        const lastHandler = handlers[handlers.length - 1];
        if (lastHandler) {
          lastHandler.handler();
          unregisterHandler(lastHandler.id);
        }
      }
    },
    [handlers]
  );
  React.useEffect(() => {
    document.addEventListener("keydown", handleOnEscape, false);
    return () => {
      document.removeEventListener("keydown", handleOnEscape, false);
    };
  }, [handleOnEscape]);
  return /* @__PURE__ */ React.createElement(EscapeHandlerStackContext.Provider, { value: { registerHandler, unregisterHandler } }, children);
};
export {
  EscapeHandlerStackContext,
  EscapeHandlerStackProvider,
  useEscapeHandlerStack
};
//# sourceMappingURL=EscapeHandlerStack.js.map
